import React from "react"
import styles from "styles/footer.module.scss"
import { Link, navigate } from "gatsby"

const Footer = ({ showBottom }) => {
  return (
    <div>
      {showBottom ? (
        <div className={styles.cta}>
          <div>
            <h6 className="text-white w-11/12 lg:w-9/12 xl:w-7/12 mx-auto text-center text-4xl md:text-5xl font-medium">
              See how Woodcore products fits your needs
            </h6>
            <div className="mt-10 flex-col md:flex-row flex items-center justify-center">
              <button
                className="bg-green py-4 text-base font-medium w-48 rounded-sm text-white hover:bg-green-dark duration-500"
                onClick={() => {
                  navigate("/contact")
                }}
              >
                Contact us
              </button>
              <button
                className="bg-transparent border border-green py-4 text-base font-medium w-48 rounded-sm text-white mt-5 md:mt-0 md:ml-5 hover:bg-green duration-500"
                onClick={() => {
                  navigate("/contact")
                }}
              >
                Request a demo
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <div className="py-16 w-11/12 mx-auto lg:flex justify-between items-start">
        <div>
          <p className="font-semibold text-grey-100 text-lg">
            GET MORE INFORMATION
          </p>
          <form
            className="flex mt-6"
            action="https://woodcoreapp.us17.list-manage.com/subscribe/post?u=de7b51686194f47e53f7e9908&amp;id=a2d0aa7a02"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            target="_blank"
          >
            <input
              className="h-14 border border-r-0 border-grey-300 w-64 px-4 text-grey-100 placeholder-grey-200 text-sm"
              type="email"
              name="EMAIL"
              id="mce-EMAIL"
              placeholder="What is your email"
              required
            />
            <button
              type="submit"
              name="subscribe"
              id="mc-embedded-subscribe"
              className="flex items-center justify-center bg-green h-14 w-16 hover:bg-green-dark duration-500"
            >
              <svg
                width="10"
                height="18"
                viewBox="0 0 10 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="slide"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.382524 17.6182C0.892557 18.1273 1.71948 18.1273 2.22951 17.6182L9.61748 10.2451C9.90005 9.96311 10.0261 9.58402 9.99553 9.21542C10.0025 8.87287 9.87514 8.52811 9.61345 8.26671L2.22886 0.890217C1.71906 0.380976 0.892506 0.380976 0.382707 0.890217C-0.127093 1.39946 -0.127094 2.2251 0.382706 2.73434L6.91307 9.25753L0.382524 15.775C-0.127508 16.284 -0.127508 17.1092 0.382524 17.6182Z"
                  fill="white"
                />
              </svg>
            </button>
          </form>

          <div className="flex items-center mt-8">
            <div className="mr-4">
              <object
                data={require("images/instagram.svg")}
                type="image/svg+xml"
              >
                Instagram Logo
              </object>
            </div>
            <div className="mr-4">
              <object data={require("images/twitter.svg")} type="image/svg+xml">
                Twitter Logo
              </object>
            </div>
            <div className="mr-4">
              <object
                data={require("images/facebook.svg")}
                type="image/svg+xml"
              >
                Twitter Logo
              </object>
            </div>
          </div>
        </div>
        <div className="md:flex items-start mt-10 lg:mt-0">
          <ul>
            <li className="font-semibold text-lg text-grey-100 hover:text-green duration-500 mb-4">
              WoodCore
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              <Link to="/pricing">Pricing</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              <a
                href="https://doc.woodcoreapp.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Developers
              </a>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              <Link to="/features">Top Features</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              <Link to="/contact">Request a demo</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              <Link to="/contact">For Enterprise</Link>
            </li>
          </ul>
          <ul className="mt-6 md:mt-0 md:px-24">
            <li className="font-semibold text-lg text-grey-100 hover:text-green duration-500 hover:text-green duration-500 mb-4">
              ABOUT US
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 mb-4">
              <Link to="/">Home</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 mb-4">
              <Link to="/solutions">Solutions</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 mb-4">
              <Link to="/contact">Contact us</Link>
            </li>
            <li className="text-base text-grey-200 hover:text-green duration-500 mb-4">
              <Link to="/faq">FAQs</Link>
            </li>
          </ul>
          <div className="mt-6 md:mt-0">
            <p className="font-semibold text-lg text-grey-100 hover:text-green duration-500 mb-4">
              CONTACT US
            </p>
            <p
              className="text-base text-grey-200 mb-4"
              style={{ lineHeight: "30px" }}
            >
              Plot 55, Block 3,
              <br />
              Fatai Idowu Arobieke Street,
              <br />
              Lekki Phase 1, Lagos
            </p>
          </div>
        </div>
      </div>

      <footer className="w-11/12 mx-auto border-t border-grey-300 h-24  flex items-center">
        <Link to="/privacy-policy">
          <p className="text-grey-100 text-sm mr-8 hover:text-green duration-500">Terms of Use</p>
        </Link>
        <Link to="/privacy-policy">
          <p className="text-grey-100 text-sm mr-8 hover:text-green duration-500"> Privacy Policy</p>
        </Link>
        <p className="text-grey-100 text-sm mr-8">
          {" "}
          &copy; Woodcore {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  )
}

export default Footer
